import React from "react";
import { FormattedMessage } from "react-intl";

interface Props {
  messageId: string;
  header: boolean;
  values?: { [key: string]: any };
}

export const Paragraph: React.FC<Props> = ({ messageId, header, values }) => {
  const styles = header
    ? `text-brand-dark_blue font-semibold text-center p-4`
    : `text-gray-600 italic p-4`;

  return (
    <div className={styles}>
      <FormattedMessage
        id={messageId}
        defaultMessage='lorem ipsum dolor set amet...'
        values={{ ...values }}
      />
    </div>
  );
};

export default Paragraph;
